

















import VueOptions from '@utils/VueOptions'
import AudienceCreativeForm from '@superComponents/AudienceCreative/AudienceCreativeForm'

settings =
  name: 'AudienceCreativeBulkEdit'

  resources:
    audience_creatives:
      resourceName: 'audience_creative'
      slug: 'audience_creatives'
      fetch: false

  vue:
    components: {
      AudienceCreativeForm,
    }

    data: ->
      audienceCreativeBulkEditModal:
        show: true

      form:
        data: {}
        fields: {}
        errors: {}

    computed:
      audienceCreativeIds: ->
        return [] if @$route.query.audienceCreatives is 'all'
        @$route.query.audienceCreatives

      allAudienceCreatives: ->
        @$route.query.audienceCreatives is 'all'

    methods:
      hiUpdate: ->
        payload =
          audience_creative_ids: @audienceCreativeIds
          all_audience_creatives: @allAudienceCreatives
          atts: @form.data
        @triggerResource 'audience_creatives', 'bulk_edit', payload
      onAudienceCreativesBulkEdit: ->
        @hiCloseModal()

      hiCloseModal: ->
        @$router.back()

export default VueOptions.vue settings
